<template>
  <div class="home">
    <!-- Hero section -->
    <section class="home__section service">
      <v-container>
        <v-row class="justify-start">
          <v-col cols="12" sm="10" md="10" lg="7">
            <h1 class="service__title">
              Simplificamos <br> la gestión de <br> talentos
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="home__section service-information">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="12" lg="12"  class="service-information__col">
            <div style="padding:10px;display:flex;flex-direction:column">
              <h3 class="service-information__title">
                PUBLICACIÓN DE OFERTA
              </h3>
              <h4 class="service-information__subtitle">
                  ¡Publica con nosotros y llega a mas talentos que buscan su trabajo soñado!
              </h4>
              <p class="service-information__text">
                Tú los recibirás cómodamente en nuestro ATS
                  (Applicant Tracking System) donde podrás
                  visualizar y gestionar el proceso de reclutamiento
                  completo de manera simple e intuitiva.
                  Simplemente mueve a un candidato de un estado a
                  otro.
              </p>
              <v-btn
                  to="/pricing#prices"
                  color="#e8842c"
                  dark
                  elevation="0"
                  style="font-weight:600; align-self:center"
              >
                  VER PLANES
              </v-btn>
            </div>
            <img class="service-information__img" src="../assets/images/service-1.webp" >
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="home__section service-information" style="background-color: #08acfc;">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="12" lg="12" class="service-information__col">
            <img class="service-information__img" src="../assets/images/service-2.webp" >
            <div style="padding:10px;display:flex;flex-direction:column">
              <h3 class="service-information__title" style="color:white !important;text-align:left !important;">
                BÚSQUEDA DE TALENTOS
              </h3>
              <h4 class="service-information__subtitle" style="color:white !important;text-align:left !important;">
                  ¡Nos encargamos de todo el proceso de Búsqueda de Talentos!
              </h4>
              <p class="service-information__text" style="color:white !important;">
                Comenzamos entendiendo tus necesidades y levantando
                  un perfil que dirige la búsqueda, luego buscamos a los
                  mejores talentos para que generen impacto en tu
                  organización y no descansamos hasta que estés conforme
                  y seguro de la persona que vas a contratar.
              </p>
              <v-btn
                  @click="openMail"
                  color="#e8842c"
                  dark
                  elevation="0"
                  style="font-weight:600; align-self:center"
              >
                  VER PLANES
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="home__section service-information" style="background-color: #0874c4">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="12" lg="12" class="service-information__col">
            <div style="padding:10px;display:flex;flex-direction:column">
              <h3 class="service-information__title" style="color:white !important;">
                EVALUACIONES PSICOLABORALES
              </h3>
              <h4 class="service-information__subtitle" style="color:white !important;">
                Analizamos considerando lo técnico como requisito, pero mirando más allá.
              </h4>
              <p class="service-information__text" style="color:white !important;">
                Realizamos entrevistas por competencias identificando
                  variables emocionales, laborales y personales de el/la
                  postulante, lo que permite predecir el comportamiento
                  en el rol y dentro de la organización.
              </p>
              <v-btn
                  @click="openMail"
                  color="#e8842c"
                  dark
                  elevation="0"
                  style="font-weight:600; align-self:center"
              >
                  VER PLANES
              </v-btn>
            </div>
            <img class="service-information__img" src="../assets/images/service-3.webp" >
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="home__section service-information">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="12" lg="12" class="service-information__col">
            <img class="service-information__img" src="../assets/images/service-4.webp" >
            <div style="padding:10px;display:flex;flex-direction:column">
              <h3 class="service-information__title" style="text-align:left !important;">
                FILTROS CURRICULARES
              </h3>
              <p class="service-information__text" style="text-align:left !important;">
                Te entregamos un listado con detalles que te
                  permitirán conocer a las personas que más se
                  ajusten a tu perfil de búsqueda, para que
                  los/las conozcas y te acerques a hacer el match
                  de talento.
              </p>
              <v-btn
                  @click="openMail"
                  color="#e8842c"
                  dark
                  elevation="0"
                  style="font-weight:600; align-self:center"
              >
                  VER PLANES
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="home__section service-information" style="background-color: #08acfc;">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="12" lg="12" class="service-information__col">
            <div style="padding:10px;display:flex;flex-direction:column">
              <h3 class="service-information__title" style="color:white !important;">
                CONSULTORÍAS
              </h3>
              <h4 class="service-information__subtitle">
                  Te ayudamos a alcanzar el mejor POTENCIAL de tu organización
              </h4>
              <p class="service-information__text" style="color:white !important;">
              Asesoramos y acompañamos el camino de
                  TRANSFORMACIÓN de tu organización hacia su
                  mejor expresión, para que logre el IMPACTO que
                  busca. <br> <br>
                  Nuestra mirada es personalizada y enfocada en las
                  necesidades de la organización, con un foco en la
                  integridad de las personas y el entorno.
              </p>
              <v-btn
                  @click="openMail"
                  color="#e8842c"
                  dark
                  elevation="0"
                  style="font-weight:600; align-self:center"
              >
                  VER PLANES
              </v-btn>
            </div>
            <img class="service-information__img" src="../assets/images/service-5.webp" >
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="home__section service-information" style="background-color: #0874c4">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" sm="10" md="12" lg="12" class="service-information__col">
            <img class="service-information__img" src="../assets/images/service-6.webp">
            <div style="padding:10px;display:flex;flex-direction:column">
              <h3 class="service-information__title" style="color:white !important;text-align:left !important;">
                  CHARLAS Y TALLERES
              </h3>
              <h4 class="service-information__subtitle" style="color:white !important;text-align:left !important;">
                Compartimos todo nuestro know how para impulsar a tu organización <br><br>
              </h4>
              <p class="service-information__text" style="color:white !important;">
                Co-creamos espacios de conocimiento y
                  desarrollo de habilidades para fortalecer los
                  talentos de tu organización, potenciarlos
                  como Agentes de cambio y facilitar el logro de
                  los objetivos estratégicos.
              </p>
              <v-btn
                  @click="openMail"
                  color="#e8842c"
                  dark
                  elevation="0"
                  style="font-weight:600; align-self:center"
              >
                  VER PLANES
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <ContactModal :isOpen="isDisplayModal" @close="isDisplayModal = false"/>

    <article class="pricing__section pricing__contact d-none d-sm-block">
      <v-container>
        <v-row>
          <v-col style="display:flex;flex-direction:column;align-items:center;justify-content:center">
            <h2 class="pricing__title pricing__title--white">CONSULTAS / DUDAS</h2>
            <p class="pricing__text">
              Si tienes consultas o dudas, ¡contáctanos! Felices de ayudarte.
            </p>
            <v-btn
              target="_blank"
              class="pricing__contact-btn mt-4"
              x-large
              outlined
              @click="displayModal()"
            >CONTÁCTANOS</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </article>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { meta } from "@/libs/mixins";
import ContactModal from "@/components/ContactModal";

export default {
    name: "Home",
    components: {
        ContactModal,
    },

    mixins: [meta],

    metaInfo() {
        return {
            ...this.getMetaInfo(),
            titleTemplate: null,
        };
    }, 
    
    data() {
        return {
            timerId: null,
            searchText: "",
            searchedText: "",
            loading: true,
            isDisplayModal: false,
        };
    },
    
    computed: {
        ...mapGetters("offers", ["featuredOffers", "normalOffers"]),

        thereAreOffers() {
            return this.normalOffers.length > 0 || this.featuredOffers.length > 0;
        },
    },

    methods: {
        ...mapActions("offers", ["getOffers"]),

        searchKeyInput() {
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                this.searchOffer();
            }, process.env.VUE_APP_SEARCH_TIMEOUT);
        },
        async searchOffer() {
            if (this.searchedText != this.searchText) {
                await this.getOffers(this.searchText.replace(/ /g, ","));
                this.searchedText = this.searchText;
            }
            this.loading = false;
        },
        async onSearchClear() {
            this.loading = true;
            await this.getOffers();
            this.loading = false;
        },
        displayModal() {
            this.isDisplayModal = true;
            console.log(this.isDisplayModal);
        },
        openMail() {
            const email = "hola@trabajoconsentido.com";
            const subject = "ver planes";
            window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
        }
    },
};
</script>

<style>

  .service-information__img{
      display: flex !important;
  }

  @media (max-width: 768px) {
    .service-information__img{
      display: none !important;
    }
  }
</style>
